module.exports = {
          srcSet: __webpack_public_path__ + "9c8530ffb13c3f31b4d103aff1f35044-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "9c8530ffb13c3f31b4d103aff1f35044-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "9c8530ffb13c3f31b4d103aff1f35044-120.png",
          toString:function(){return __webpack_public_path__ + "9c8530ffb13c3f31b4d103aff1f35044-120.png"},
          
          width: 120,
          height: 120
        }